jQuery(($) => {

    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Trigger: Close Modal
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    $(document).on('click', '.js-close-modal', function () {
        var modal = $(this).closest('.m-modal'),
            iframe = modal.find('.a-iframe');

        modal.removeClass('m-modal--open');

        if (iframe[0]) {
            iframe.attr('src', '');
        }
    });


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 
    // ✅ Molecule: Modal
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡ 

    function closeModal(el) {
        const $modal       = $(el).closest(".m-modal");
        const triggerId    = $modal.data("controlledby");
        const $media       = $modal.find('audio');
        const $videoIframe = $modal.find('.m-video-player__video-iframe');

        if ($('body').css('overflow', 'hidden')) {
            $('body').removeAttr('style');
        }


        $modal
            .removeClass("m-modal--open")
            .attr("tabindex", "-1");

        if (triggerId) {
            $(`#${triggerId}`)
                .removeClass('m-modal-trigger__trigger--active')
                .focus();
        }

        if ($media[0]) {
            $media.trigger('pause');
            $media.prop("currentTime", 0);
        }

        if ($videoIframe) {
            $videoIframe.attr('src', '');
        }
    }

    function openModal(id, focusOnModal) {
        const $modal       = $(`#${id}`);
        const $videoIframe = $modal.find('.m-video-player__video-iframe');
        const $gForm       = $modal.find('.m-form-card__gravity-form .gform_wrapper');

        if (($('.o-header--open')[0]) && $('body').css('overflow', 'hidden')) {
            $('body').removeAttr('style');
            $('.o-header').removeClass('o-header--open');
            $('.o-header__navigation-outer').removeClass('o-header__navigation-outer--open');
            $('.a-hamburger').removeClass('a-hamburger--toggled');
        }

        if (!$('body').css('overflow', 'hidden')) {
            $('body').css('overflow', 'hidden');
        }

        $modal
            .addClass("m-modal--open")
            .attr("tabindex", "1");

        if ($videoIframe) {
            var src = $videoIframe.attr('data-src');
            $videoIframe.attr('src', src);
        }

        if ($gForm) {
            $gForm.css('display', 'block');
        }

        if (focusOnModal) {
            setTimeout(function () {
                $modal.focus();
            }, 100);
        } else {
            const $focusable = $modal.find(
                'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
            );
            const $firstFocusable = $focusable[1];

            setTimeout(function () {
                $firstFocusable.focus();
            }, 100);
        }
    }

    function toggleModal(el, id, focusOnModal) {
        const $modal = $(`#${id}`);

        if ($modal.hasClass('m-modal--open')) {
            closeModal($modal.find('*:first'));
        } else {
            openModal(id, focusOnModal);
        }
    }

    if ($(".m-modal")[0]) {
        $(".m-modal__close, .m-modal__overlay").click(function () {
            closeModal(this);
        });

        $(window).on('load resize', function () {
            if ($('.m-modal--open')[0]) {
               closeModal($('.m-modal--open'));
            }
        });

        $(".m-modal").keydown(function (e) {
            if (e.key === "Tab") {
                const $focusable = $(this).find(
                    'button, [href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])'
                );

                const $firstFocusable = $focusable[0];
                const $lastFocusable  = $focusable[$focusable.length - 1];

                if (
                    $(e.target).is($lastFocusable) && !e.shiftKey ||
                    ($(e.target).is($firstFocusable) && e.shiftKey)
                ) {
                    e.preventDefault();

                    if ($(e.target).is($lastFocusable)) {
                        $firstFocusable.focus();
                    } else {
                        $lastFocusable.focus();
                    }
                } else if ($(e.target).is(".m-modal")) {
                    e.preventDefault();

                    $firstFocusable.focus();
                }
            } else if (e.key === "Escape" || e.key === "Esc") {
                if (!$(e.target).is('.a-select *')) {
                    closeModal(this);
                }
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Molecule: Modal Trigger
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    if ($(".m-modal-trigger__trigger")[0]) {
        $(".m-modal-trigger__trigger").mousedown(function () {
            const modalId = $(this).attr("aria-controls");

            $(this).toggleClass('m-modal-trigger__trigger--active');
            toggleModal(this, modalId, true);
        });

        $(".m-modal-trigger__trigger").keydown(function (e) {
            if (e.key === 'Enter' || e.key === 'spacebar' || e.key === ' ') {
                e.preventDefault();

                const modalId = $(this).attr("aria-controls");

                $(this).addClass('m-modal-trigger__trigger--active');
                openModal(modalId);
            }
        });
    }


    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ FormModalFunctionality
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

    function updateGFormModal(fields, formId){
        var formFields = fields,
            gformId    = formId,
            gFields    = $("#modal-trigger_" + gformId + "_modal .m-gravity-form .gform_fields"),
            gFormPage  = gFields.parent().parent();

            gFormPage.addClass('fields-loading');

        if (formFields && gFields) {
            formFields.each(function() {
                var val    = $(this).val(),
                    id     = $(this).attr('data-id'),
                    ginput = gFields.find('.gfield[id="field_' + id + '"');

                ginput.find('input').val(val);
            })

            $("#gform_target_page_number_2").val("2");
            $("#gform_" + gformId).trigger("submit", [true]);

            $("#gform_wrapper_" + gformId).find('form').addClass('loading');
        }
    }

    if ($('.m-form')) {
        $('.m-form').validate({
            rules: {
                phone: {
                    phoneUS: true
                },
            },
            submitHandler: function (form) {
                var formContainer     = $(this),
                    formInner         = formContainer[0],
                    fields            = formInner['currentElements'],
                    currentForm       = formInner['currentForm'],
                    currentFormObject = $(currentForm),
                    formId            = currentFormObject.attr('data-form-id'),
                    formId            = formId.replace('gform__', '');

                updateGFormModal(fields, formId);

                openModal('modal-trigger_' + formId + '_modal');
            }
        });
    }
});